module.exports = __webpack_public_path__ + "performance-testing.15_8TnyR.svg";